import * as React from "react";

const EventMap = (props) => (
  <svg
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="m9.677 5-.637.61-3.404 3.435L5 9.682l.637.61 5.092 5.126-.582.582 5.84 5.847.58-.583 5.092 5.127.637.609.637-.61 3.431-3.463.636-.61-6.004-6.012c.545-1.472.235-3.2-.941-4.378a4.133 4.133 0 0 0-2.934-1.192c-.49 0-.975.108-1.44.277L10.314 5.61 9.677 5Zm0 2.493 4.483 4.49-2.187 2.189-4.483-4.49 2.187-2.189Zm7.444 4.988a2.367 2.367 0 0 1 1.689 4.046l-2.575 2.549-.249.249L12.666 16l2.684-2.688.11-.138c.062-.062.129-.111.194-.166l.167-.139c.39-.26.85-.388 1.3-.388Zm2.878 5.348 4.483 4.488-2.186 2.19-4.484-4.49L20 17.83ZM9.742 17.395l-1.48.165c.41 3.673 3.716 6.343 7.375 5.947l-.16-1.48c-2.857.309-5.414-1.752-5.735-4.632Zm-2.961.32-1.48.165c.592 5.311 5.363 9.163 10.652 8.591l-.16-1.48c-4.486.485-8.508-2.758-9.012-7.276Z"
      fill="currentColor"
    />
  </svg>
);

export default EventMap;
